module.exports = __webpack_public_path__ + "img/real_estate.85e6d5ac.jpeg";